/**
 * SummaryTab
 * @typedef {Object} SummaryTab - aggregate summary tab for period
 * @property {string} tabTitle - tab title
 * @property {boolean} validForUse - is the tab valid for use?
 * @property {string} sourceStandardTemplateId - selected standard template id
 * @property {Object} aggregateData - aggregate data list
 * @property {Object} standardTemplateLevel - standard template level data
 */

/**
 * SummaryTab
 * @typedef {Object} SummaryTabResult - aggregate summary tab for period
 * @property {string} tabTitle - tab title
 * @property {boolean} validForUse - is the tab valid for use?
 * @property {string} sourceStandardTemplateId - selected standard template id
 * @property {Object} results - aggregate data list
 * @property {Object} standardTemplateLevel - standard template level data
 */

/**
 * Response
 * @typedef {Object} ApiResponse - api response data
 * @property {string} id - unique identifier
 * @property {Array<SummaryTab>} summaryTabs - List of aggregate summary tabs
 */

/**
 * Update aggregate response for italy
 * @param {ApiResponse} response - api response data
 * @returns {Object<{id: string, summaryTabs: SummaryTabResult}>}
 */
export const updateResponse = (response = {}) => ({
  ...response,
  summaryTabs:
    response.summaryTabs?.map(tab => ({
      tabTitle: tab?.tabTitle,
      validForUse: !!tab?.validForUse,
      results: tab?.aggregateData || [],
      standardTemplateLevel: tab?.standardTemplateLevel || {},
    })) || [],
});
